import { render, staticRenderFns } from "./marketingFreightSubsidyRecords.vue?vue&type=template&id=081db7df&scoped=true&"
import script from "./marketingFreightSubsidyRecords.vue?vue&type=script&lang=js&"
export * from "./marketingFreightSubsidyRecords.vue?vue&type=script&lang=js&"
import style0 from "./marketingFreightSubsidyRecords.vue?vue&type=style&index=0&id=081db7df&scoped=true&lang=css&"
import style1 from "./marketingFreightSubsidyRecords.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081db7df",
  null
  
)

export default component.exports